import { render, staticRenderFns } from "./SectionGallery.vue?vue&type=template&id=d00f6028&scoped=true&"
import script from "./SectionGallery.vue?vue&type=script&lang=js&"
export * from "./SectionGallery.vue?vue&type=script&lang=js&"
import style0 from "./SectionGallery.vue?vue&type=style&index=0&id=d00f6028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00f6028",
  null
  
)

export default component.exports